import { Injectable, Injector } from '@angular/core';
import { HttpRequest, HttpHandler, HttpEvent, HttpInterceptor } from '@angular/common/http';
import { Observable, throwError, BehaviorSubject } from 'rxjs';
import { shareReplay, catchError, switchMap, tap, finalize } from 'rxjs/operators';

import { UserService } from 'app/services/user.service';
import { Router } from '@angular/router';
import { ToastService } from 'ng-uikit-pro-standard';
import { Globals } from 'app/services/globals';

@Injectable()
export class ApiInterceptor implements HttpInterceptor {

    private tokenSubject: BehaviorSubject<string> = new BehaviorSubject<string>(null);
    private refreshToken$: Observable<boolean>;

    constructor(private inj: Injector, private _router: Router, private toastService: ToastService,
                private globals: Globals) {}

    addAuthHeader(request) {
        let userService = this.inj.get(UserService);
        request = request.clone({
            withCredentials: true,
            setHeaders: {
                "Authorization": `Bearer ${userService.access_token}`
            }
        });

        return request;
    }

    intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {

        if (request.url.indexOf(this.globals.api_base_url || ' ') == -1 &&
            request.url.indexOf(this.globals.api_public_base_url) == -1) {
            return next.handle(request);
        }

        return next.handle(this.addAuthHeader(request)).pipe(
            catchError(err => {
                if (err.status === 401 && !request.url.endsWith('/login/refresh')) {
                    return this.handle401Error(request, next);
                } else {
                    return this.handleError(err, request);
                }
            })
        );
    }

    private handle401Error(request: HttpRequest<any>, next: HttpHandler) {
        if (!this.refreshToken$) {
            const auth = this.inj.get(UserService);
            this.refreshToken$ = auth.refreshToken().pipe(
                tap(success => {
                    if (success) {
                        this.tokenSubject.next(null);
                    }
                }),
                finalize(() => {
                    this.refreshToken$ = null;
                }),
                shareReplay(1)
            );
        }

        return this.refreshToken$.pipe(
            switchMap((refreshSuccessful: boolean) => {
                if (refreshSuccessful) {
                    return next.handle(this.addAuthHeader(request));
                } else {
                    return this.logoutUsers();
                }
            }),
            catchError(error => {
                return this.logoutUsers();
            })
        );
    }
        
    private handleError(err, request) {
        let userService = this.inj.get(UserService);

        if (err.status === 400 && request.url.endsWith('/login/refresh')) {
            userService.logout();
            return throwError(err);
        } else if (err.status === 403) {
            this.toastService.error("Forbidden!");
        }

        let error = err.error || err.statusText;
        error.status = err.status;

        return throwError(error);
    }

    private logoutUsers() {
        const userService = this.inj.get(UserService);
        userService.logout();
        return throwError('');
    }
}
